export default "__VITE_ASSET__DZLav6LP__"